
import { Component, Vue } from "vue-property-decorator";
import WizardCart from "@/views/_components/WizardCart.vue";
import { namespace } from "vuex-class";
import CheckoutPersonalInfo from "@/views/_components/CheckoutPersonalInfo.vue";
import { Cart } from "@/types/Cart";
import { CartItemPaymentTerms } from "@/types/cart-item";
import IUser from "@/models/protocols/IUser";
const { State } = namespace("Root");

@Component({
  components: {
    WizardCart,
    CheckoutPersonalInfo,
  },
})
export default class WizardEnd extends Vue {
  @State("cart") cart!: Cart;
  @State("user") user!: IUser;

  constructor() {
    super();
  }

  created() {
    if (this.cart.items.length == 0 && !this.cart.completed) {
      this.$router.push({ name: "home" });
    }
    window.scrollTo(0, 0);
  }

  getPaymentTermsName(payment_terms: CartItemPaymentTerms) {
    switch (payment_terms) {
      case CartItemPaymentTerms.Monthly:
        return "Monthly Payment";
      case CartItemPaymentTerms.InFull:
        return "Full Payment";
      case CartItemPaymentTerms.AnnualAutoRenew:
        return "Annual Auto Payment";
      default:
        return "";
    }
  }
}
